import _Vue from 'vue'

/**
 * ロード時のオーバーレイ表示メソッド
 */
export default {
  /**
   * plugin登録時に実行される処理
   *
   * @param Vue Vueのコンストラクタ
   */
  install(Vue: typeof _Vue): void {
    const overlayId = 'overlayLoading'

    /**
     * オーバーレイ開始
     */
    const start = function (): void {
      // 既に表示済みの場合は終了
      const displayed = document.getElementById(overlayId)
      if (displayed) {
        return
      }

      // オーバーレイ用div生成
      const overlay = document.createElement('div')
      overlay.id = overlayId
      // ロード中画像の設定
      const loadingImage = document.createElement('div')
      loadingImage.id = 'loadingImage'
      overlay.appendChild(loadingImage)

      // 表示
      document.body.appendChild(overlay)
    }

    /**
     * オーバーレイ終了
     */
    const complete = function (): void {
      const overlay = document.getElementById(overlayId)
      if (overlay) {
        overlay.remove()
      }
    }

    // プロトタイプ登録
    Vue.prototype.$loading = { start, complete }
  },
}

declare module 'vue/types/vue' {
  /**
   * 呼び出し時のインターフェース定義
   */
  interface Vue {
    /** ローディング時のオーバーレイ表示処理 */
    $loading: {
      /** 開始 */
      start: () => void
      /** 終了 */
      complete: () => void
    }
  }
}
